// Сохранённый результат по прямой ссылке. SMY-75
//
// Обычный путь к результату — чат, в котором он лежит: карточка стоит там же,
// где вопрос, которым её получили. Этот адрес нужен двум случаям: результату,
// у которого чата не осталось, и старым закладкам, заведённым до того, как
// экраны результата переехали в ленту.

import { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router'
import type { StoredArtifact } from '@smyslika/api-client'

import { useSession } from '../session.tsx'
import { Shell } from '../shell/Shell.tsx'
import { ResultCard } from '../cards/index.tsx'

/** Экран без результата: сюда попадают по адресу или после отмены. */
function Nothing({ children }: { children: string }) {
  const navigate = useNavigate()
  return (
    <Shell>
      <div className="content">
        <p className="muted">{children}</p>
        <button type="button" className="btn btn--primary" onClick={() => navigate('/')}>
          В чат
        </button>
      </div>
    </Shell>
  )
}

export function ArtifactScreen() {
  const { id } = useParams()
  const { artifacts } = useSession()

  const [stored, setStored] = useState<StoredArtifact | null>(null)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    if (id == null) return
    let alive = true
    setStored(null)
    setError(null)
    artifacts.read(id).then(
      (a) => alive && setStored(a),
      (e: Error) => alive && setError(e.message),
    )
    return () => {
      alive = false
    }
  }, [artifacts, id])

  if (error != null) return <Nothing>{error}</Nothing>
  if (stored == null) {
    // Без кнопки «в чат»: ожидание — не тупик, и предлагать выход из него
    // значит намекать, что дальше ничего не будет.
    return (
      <Shell>
        <div className="content">
          <p className="muted">Открываю результат…</p>
        </div>
      </Shell>
    )
  }

  return (
    <Shell>
      <div className="chat">
        <ResultCard artifact={stored} charged={stored.charged} unit={stored.unit} runId={stored.runId} />
      </div>
    </Shell>
  )
}
